import React, { useState, useEffect } from 'react';
import SearchIcon from "@mui/icons-material/Search";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { MdPersonAddAlt1 } from "react-icons/md";
import admissionService from "../../../Services/admissionService";
import AdmissionTabs from "../Admission/AdmissionDetails";

const Admission = () => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [admissions,      setAdmissions]      = useState([]);
  const [loading,         setLoading]         = useState(true);
  const [error,           setError]           = useState(null);
  const [search,          setSearch]          = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  const viewingDetail = searchParams.get("view") === "detail";

  useEffect(() => {
    const fetchAdmissions = async () => {
      try {
        setLoading(true);
        const data = await admissionService.fetchAllAdmissions();
        if (data.responseCode === 200) {
          setAdmissions(data.admissions);
        } else {
          setError("Failed to fetch admissions");
        }
      } catch (err) {
        setError("Server error. Please check if backend is running.");
      } finally {
        setLoading(false);
      }
    };
    fetchAdmissions();
  }, []);

  useEffect(() => {
    if (!viewingDetail) {
      setSelectedPatient(null);
    }
  }, [viewingDetail]);

  const handleView = async (id) => {
    try {
      const data = await admissionService.fetchAdmissionById(id);
      if (data.responseCode === 200) {
        setSelectedPatient(data.admission);
        setSearchParams({ view: "detail" });
      }
    } catch (err) {
      console.error("Error fetching admission:", err);
    }
  };

  const filtered = admissions.filter((a) =>
    a.full_name.toLowerCase().includes(search.toLowerCase()) ||
    a.CNIC.toLowerCase().includes(search.toLowerCase())
  );

  if (viewingDetail && selectedPatient) {
    return (
      <div className="p-3 sm:p-6">
        <AdmissionTabs admission={selectedPatient} />
      </div>
    );
  }

  return (
    <div className='p-3 sm:p-6'>

     
     <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-5 shadow-sm">
  <div>
    <h1 className="text-[16px] sm:text-[17px] font-[500] text-gray-800">
      Admission Table
    </h1>
    <p className="text-[12px] text-gray-400 mt-0.5">
      {admissions.length} records found
    </p>
  </div>

  <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
    <div className="relative">
      <SearchIcon
        className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
        style={{ fontSize: 16 }}
      />
      <input
        type="search"
        placeholder="Search by name or CNIC..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="pl-8 pr-3 py-[7px] w-full sm:w-[230px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg"
      />
    </div>

    <Link to="AddAdmit" className="w-full sm:w-auto">
      <button className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-4 py-[7px] rounded-lg">
        + New Admission
      </button>
    </Link>
  </div>
</div>
      
      <div className='hidden md:block border border-gray-200 bg-white rounded-xl overflow-hidden shadow-sm'>
        <div className="overflow-x-auto">
          <table className='w-full min-w-[700px]'>
            <thead>
              <tr className="bg-[#215187] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">Sr No.</th>
                <th className="py-3 px-4 text-left">Check-up Date</th>
                <th className="py-3 px-4 text-left">Patient Name</th>
                <th className="py-3 px-4 text-left">Blood Group</th>
                <th className="py-3 px-4 text-left">Contact</th>
                <th className="py-3 px-4 text-center">CNIC</th>
                <th className="py-3 px-4 text-center">Address</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={8} className="py-8 text-center text-[13px] text-gray-400">Loading...</td></tr>
              ) : error ? (
                <tr><td colSpan={8} className="py-8 text-center text-[13px] text-red-400">{error}</td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan={8} className="py-8 text-center text-[13px] text-gray-400">No admissions found.</td></tr>
              ) : (
                filtered.map((admission, index) => (
                  <tr key={admission.id} className="border-t hover:bg-gray-50 text-[13px] transition-colors">
                    <td className='py-3 px-4 border-b text-left'>{index + 1}</td>
                    <td className='py-3 px-4 border-b text-left'>{admission.checkup_date}</td>
                    <td className='py-3 px-4 border-b text-left font-[500]'>{admission.full_name}</td>
                    <td className='py-3 px-4 border-b text-left'>{admission.blood_group || "—"}</td>
                    <td className='py-3 px-4 border-b text-left'>{admission.contact_number}</td>
                    <td className='py-3 px-4 border-b text-center'>{admission.CNIC}</td>
                    <td className='py-3 px-4 border-b text-center'>{admission.address}</td>
                    <td className='py-3 px-4 border-b text-center'>
                      <button
                        onClick={() => handleView(admission.id)}
                        className="inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-[#215187]/10 transition-colors group"
                        title="View admission details"
                      >
                        <MdOutlineRemoveRedEye className="text-[18px] text-gray-400 group-hover:text-[#215187] transition-colors" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      
      <div className='md:hidden flex flex-col gap-3'>
        {loading ? (
          <div className="py-10 text-center text-[13px] text-gray-400">Loading...</div>
        ) : error ? (
          <div className="py-10 text-center text-[13px] text-red-400">{error}</div>
        ) : filtered.length === 0 ? (
          <div className="py-10 text-center text-[13px] text-gray-400">No admissions found.</div>
        ) : (
          filtered.map((admission, index) => (
            <div
              key={admission.id}
              className="bg-white border border-gray-200 rounded-xl px-4 py-4 shadow-sm"
            >
             
              <div className="flex items-start justify-between gap-2 mb-3">
                <div className="flex items-center gap-2 min-w-0">
                  <span className="text-[11px] font-[600] text-[#215187] bg-[#215187]/10 px-2 py-0.5 rounded-full flex-shrink-0">
                    #{index + 1}
                  </span>
                  <span className="text-[14px] font-[500] text-gray-800 truncate">{admission.full_name}</span>
                </div>
                <button
                  onClick={() => handleView(admission.id)}
                  className="flex items-center gap-1.5 text-[12px] text-[#2F6DB4] font-[500] hover:text-[#215187] transition-colors flex-shrink-0 bg-[#2F6DB4]/8 hover:bg-[#215187]/10 px-2.5 py-1 rounded-lg"
                  title="View admission details"
                >
                  <MdOutlineRemoveRedEye className="text-[15px]" />
                  View
                </button>
              </div>

             
              <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-[12px]">
                <div>
                  <p className="text-gray-400 mb-0.5">Check-up Date</p>
                  <p className="text-gray-700 font-[500]">{admission.checkup_date || "—"}</p>
                </div>
                <div>
                  <p className="text-gray-400 mb-0.5">Blood Group</p>
                  <p className="text-gray-700 font-[500]">{admission.blood_group || "—"}</p>
                </div>
                <div>
                  <p className="text-gray-400 mb-0.5">Contact</p>
                  <p className="text-gray-700 font-[500]">{admission.contact_number || "—"}</p>
                </div>
                <div>
                  <p className="text-gray-400 mb-0.5">CNIC</p>
                  <p className="text-gray-700 font-[500] break-all">{admission.CNIC || "—"}</p>
                </div>
                <div className="col-span-2">
                  <p className="text-gray-400 mb-0.5">Address</p>
                  <p className="text-gray-700 font-[500]">{admission.address || "—"}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

    </div>
  );
};

export default Admission;